
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSingleDepartment, updateDepartmentEntry } from '../../Store/PHPSlice/Department';


const DepartmentEdit = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        departId: parseInt(Id),
        departNm: '',
        userId: ''
    });
    const dispatch = useDispatch();
    const singleDepart = useSelector((state) => state.DepartmentData.singleDepart || { data: [] });
    useEffect(() => {
        dispatch(fetchSingleDepartment(Id));
    }, [dispatch]);
    useEffect(() => {
        if (singleDepart.data.length > 0) {
            const item = singleDepart.data[0];
            setFormData({
                ...formData,
                departNm: item.departNm,
            });
        }
    }, [singleDepart]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const [errors, setErrors] = useState({});
    const handleSubmit = (event) => {
        event.preventDefault();
        // console.log(formData);


        dispatch(updateDepartmentEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                toast.success("Department Updated Successful");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };



    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement


    return (
        <>
            <div style={{ margin: '6% 1%' }}>
                <h2>Deparment Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={2}>

                                <Grid item xs={12} md={6} >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='departmentName' >Deparment Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='departNm'
                                                    name='departNm'
                                                    value={formData.departNm}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}

                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default DepartmentEdit;
